export default __webpack_public_path__ + "static/media/help.a2b872e3.svg";